<template>
	<transition name="modal">
		<div v-if="showMask" class="modal modal-mask">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div id="modaldrag" class="modal-header">
						<slot name="header"></slot>
					</div>
					<div class="modal-body">
						<i v-if="showClose" class="fas fa-times close" @click.prevent="$emit('close')"></i>
						<slot name="body"></slot>
					</div>
					<div class="modal-footer">
						<slot name="footer">
							<el-button @click.prevent="$emit('close')">
								OK
							</el-button>
						</slot>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="modal-dialog" role="document" style="z-index: 999  !important;" >
			<div class="modal-content">
				<div id="modaldrag" class="modal-header">
					<slot name="header"></slot>
				</div>
				<div class="modal-body">
					<i v-if="showClose" class="fas fa-times close" @click.prevent="$emit('close')"></i>
					<slot name="body"></slot>
				</div>
				<div class="modal-footer">
					<slot name="footer">
						<el-button  @click.prevent="$emit('close')">
							OK
						</el-button>
					</slot>
				</div>
			</div>
		</div>

	</transition>
</template>
<script>

export default {
    props: {
	    showModal : {
	    	type: Boolean,
		    required: false
		},
	    showMask : {
		    type: Boolean,
		    required: false,
		    default: true
	    },
	    showClose : {
		    type: Boolean,
		    required: false,
		    default: true
	    },
    },
    methods : {
        hideModal () {
           // $emit('close');
        },
        refreshData () {
            this.$emit('refreshData');
        }
    },
}
</script>
<style>
.modal-dialog .modal-content {
	border: 2px solid rgba(0, 0, 0, 0.2);
	background-color: #ffffff;
}
.modal-mask {
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .5);
	transition: opacity .3s ease;
	display: block
}

div.modal-dialog {
	position: absolute;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	max-width: 600px;
}
div.modal-header {
	background-color: #eaeaea;
	cursor:move;
	padding: 5px;
}
div.modal-dialog .close {
	position:absolute;
	top: -29px;
	right: 20px;
}
</style>
